import React, { Component } from 'react';
import { Col, Row, Button } from 'react-materialize';
import ReactJWPlayer from 'react-jw-player';
import { FormattedMessage } from 'react-intl';

import settings from '../../libs/config';
import DeviceHelper from '../../functions/device';

class LandingJumbotron extends Component {
	constructor(props) {
		super(props);

		let existing_visitor = props.getCookie('existing_visitor');
		if (!existing_visitor) {
			//this.context.mixpanel.track('First Visit');
			props.setCookie('existing_visitor', true, 1);
		}

		this.state = {
			existing_visitor,
			showVideo: 'on',
			showContent: DeviceHelper.isMobile || existing_visitor ? 'on' : 'off',
			hideOverlay: 'off',
			mute: true,
			showControls: false,
		};
	}

	hideVideo() {
		this.setState({ showVideo: 'off' });
		this.setState({ showContent: 'on' });
		this.setState({ hideOverlay: 'off' });
	}

	onVideoLoad = () => {
		setTimeout(() => this.setState({ hideOverlay: 'on' }), 1000);
	}


	onVideoEnd = () => {
		this.hideVideo();
	}

	gotoRegister() {
		this.props.history.push("/register");
	}

	handleFullScreen = () => {

	}

	handleVideoPlay = () => {
		window.jwplayer().setMute(false);
		this.setState({ hideOverlay: 'off' });
		this.showControls();
	}

	showControls = () => {
		const playerControls = document.getElementsByClassName('jw-controlbar');

		for (let i = 0; i < playerControls.length; i++) {
			playerControls[i].style.display = 'flex';
		}
	}

	render() {
		const { showVideo, mute, showContent, hideOverlay, existing_visitor } = this.state;
		
		return (
			<section className='landing-jumbotron-container'>
				<div className={`jumbotron-overlay offOnTrans ${showContent}`} />
				
				<div className={`offOnTrans zhigh ${showContent}`}>
					<Row className='valign-wrapper'>
						<Col l={8} m={8} s={12}>
							<div className='landing-jumbotron-left-container'>
								<h1 className='landing-jumbotron-title zhigh'>
									<FormattedMessage
										id="landing_jumbotron.tell_hollywood.title"
										defaultMessage={"Influence Your { break } Entertainment"}
										values={{ break: <br /> }}
									/>
								</h1>
							</div>
						</Col>
						<Col l={4} m={4} s={12}>
							<div className='landing-jumbotron-right-container zhigh'>
								<p className='jumbotron-action-text zhigh'>
									<FormattedMessage
										id="landing_jumbotron.tell_hollywood.body"
										defaultMessage={"Be first to watch and tell Hollywood what you think"}
									/>
								</p>
								<div>
									<Button className='zhigh' large waves='light' onClick={() => this.gotoRegister()}>
										<FormattedMessage
											id="landing_jumbotron.join.button"
											defaultMessage={"Join For Free"}
										/>
									</Button>
								</div>
							</div>
						</Col>
					</Row>

					<Row className='zhigh'>
						<Col s={12}>
							<div className='landing-jumbotron-bottom-container'>

							</div>
						</Col>
					</Row>
				</div>

				{!DeviceHelper.isMobile && !existing_visitor ? <div className={`primary-video-container offOnTrans zlow ${showVideo}`}>
					<ReactJWPlayer
						aspectRatio={'16:9'}
						licenseKey={settings.jwPlayerKey}
						onReady={this.onReady}
						onVideoLoad={this.onVideoLoad}
						playerId='pilotlyPlayer'
						customProps={{ skin: { name: 'six' } }}
						isAutoPlay={true}
						isMuted={mute}
						onEnterFullScreen={this.handleFullScreen}
						onOneHundredPercent={this.onVideoEnd}
						file={'https://s3.amazonaws.com/pilotly-public/pilotly/video/portal-intro-video.mp4'}
					/>
				</div> : null}

				{!DeviceHelper.isMobile && !existing_visitor ? <div className={`landing-jumbotron-overlay onOffTrans ${hideOverlay}`}>
					<div className='landing-play-btn-container'>
						<div className='landing-play-btn' onClick={this.handleVideoPlay}>

						</div>
					</div>
				</div> : null}

			</section>
		);
	}
}

export default LandingJumbotron;



// WEBPACK FOOTER //
// ./src/components/landing/LandingJumbotron.js